/**
 * Excludes spatial columns from the map config section's Color-by candidate
 * list. Despite its name, `spatialColumnKeys` (`detectSpatialColumnNames`,
 * spatialShapeDetect.ts) returns row KEYS (`column.id ?? column.name`), not
 * display names — filtering by `c.name` let a duplicate/blank-named spatial
 * column (key `col_1`) stay selectable under Color by, and picking it
 * silently read back as None in the map panel, whose own `resolveColorByPick`
 * matches against `nonSpatialColumnIds` (also keys) (PR review, P2).
 */
import type { ColumnTypeInfo } from '../../../charts/types/chartTypes';

export function nonSpatialColumnInfos(
  columnInfos: readonly ColumnTypeInfo[],
  spatialColumnKeys: readonly string[],
): ColumnTypeInfo[] {
  return columnInfos.filter((c) => !spatialColumnKeys.includes(c.key));
}
